export default class PlurallAccountExistsWithDifferentCredential extends Error {
  constructor() {
    super(`Account exists with different credential`);
  }
}
